import { render, staticRenderFns } from "./UserAnnotationTermsPanel.vue?vue&type=template&id=5ec5d684&scoped=true"
import script from "./UserAnnotationTermsPanel.vue?vue&type=script&lang=js"
export * from "./UserAnnotationTermsPanel.vue?vue&type=script&lang=js"
import style0 from "./UserAnnotationTermsPanel.vue?vue&type=style&index=0&id=5ec5d684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5d684",
  null
  
)

export default component.exports